import { Box, Typography, Button } from '@mui/material';
import React, { useState } from 'react';
import { Comment } from '../../../../services/ticketEasyService/model/ticketEasy/Comment';
import { CommentsDialog } from '../comments/CommentsDialog';
import { CommentItem } from '../comments/CommentItem';
import { Profile } from '../../../../services/profileService/model/profile/Profile';

interface MessageCommentsProps {
    comments: Comment[];
    ticketId: string;
    currentUser?: Profile;
}

export function MessageComments({ comments = [], ticketId, currentUser }: MessageCommentsProps) {
    // Filter out comments where isDeleted is true
    const activeComments = comments.filter(comment => !comment.isDeleted);
    const hasComments = activeComments.length > 0;

    return (
        <Box sx={{ mt: 1.5, pt: 1.5, borderTop: '1px solid #eee' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                    Comments {hasComments && `(${activeComments.length})`}
                </Typography>             
            </Box>            {hasComments ? (
                <Box>
                    {activeComments.map((comment, index) => (
                        <CommentItem 
                            key={comment.id || index}
                            comment={comment}
                            ticketId={ticketId}
                            isCommentOwner={!!(currentUser && comment.user === currentUser.identity)}
                        />
                    ))}
                </Box>
            ) : (
                <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', fontSize: '0.85rem' }}>
                    No comments yet
                </Typography>
            )}

          
        </Box>
    );
}